import { Box, IconButton } from "@chakra-ui/react";
import { FunctionComponent, ReactElement, ReactNode } from "react";
import { FaEdit } from "react-icons/fa";

interface SectionHeaderProps {
	title: string;
	marginBottom?: string | number; // Allows customization of bottom margin
	width?: string | number;
	showEditButton?: boolean;
	onEditButtonClick?(): void;
	customAction?: ReactNode; // Custom action to show on the right
}

const SectionHeader: FunctionComponent<SectionHeaderProps> = (props: SectionHeaderProps): ReactElement => {
	const { title, marginBottom = "10px", width = "800px", showEditButton, onEditButtonClick, customAction } = props;
	return (
		<Box
			width={width}
			height="31px"
			backgroundColor="gray.500"
			color="white"
			display="flex"
			alignItems="center"
			justifyContent="center"
			borderRadius="6px"
			fontWeight="bold"
			marginBottom={marginBottom}
			textAlign="center"
			lineHeight="31px"
			position="relative">
			{title}
			{showEditButton && (
				<IconButton
					minW="32px"
					minH="32px"
					height="32px"
					color="white"
					_hover={{ color: "gray.200" }}
					colorScheme="whiteAlpha"
					position="absolute"
					right="0px"
					variant="ghost"
					aria-label="Edit"
					onClick={() => typeof onEditButtonClick === "function" && onEditButtonClick()}
					icon={<FaEdit />}
				/>
			)}
			{customAction && (
				<Box position="absolute" right="8px">
					{customAction}
				</Box>
			)}
		</Box>
	);
};

export default SectionHeader;
